<template>
  <div class="search-new">
    <img :src="cfg.ossDomain + '/banner.png'" class="logo" @click="jumpToHome">

    <div class="search-box">
      <el-input v-model="keyword" placeholder="请输入搜索内容" class="input-with-select" @change="change">
        <el-button slot="append" icon="el-icon-search" type="primary" style="color: #007aff;" />
      </el-input>
    </div>

    <div class="list-box">
      <div v-for="(item, index) in list" :key="index" class="list" @click="jumpToDetails(item.id)">
        <img :src="cfg.imageDomain + item.img" class="img">
        <div class="title" v-html="item.title" />
        <div class="time">发布于{{ item.publishedtime | timeTransformation('YYYY-MM-DD', ['-', '-']) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { searchPageList } from '../../api/common'
export default {
  components: {
  },
  data() {
    return {
      keyword: '',
      list: []
    };
  },

  computed: {
  },
  created: function() {
  },
  mounted() {
    this.keyword = this.$route.query.keyword
    this.change(this.keyword)
  },
  methods: {
    jumpToHome() {
      this.$router.push('/');
    },
    jumpToDetails(id) {
      const route = this.$router.resolve({ path: `/news?id=${id}` });
      window.open(route.href, '_blank');
    },
    change(keyword) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      searchPageList({
        pageNo: 1,
        pageSize: 100,
        type: 16,
        keyword
      }).then(res => {
        res.data.rows.forEach(e => {
          e.title = e.title.replaceAll(keyword, `<span style="color: red;">${keyword}</span>`)
        })
        this.list = res.data.rows
        loading.close();
        console.log(res)
      }).catch(err => {
        loading.close();
        console.log(err)
      })
    }
  }
};
</script>

<style lang="less" scoped>
.search-new {
  min-height: 100%;
  background: #f6f7f8;
  .logo {
    width: 100%;
    cursor: pointer;
  }
  .search-box {
    width: 600px;
    margin: 50px auto;
  }
  .list-box {
    width: 1120px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: auto;
    gap: 27px 20px;
    margin: 0 auto;
    .list {
      width: 100%;
      padding: 10px;
      background: #FFFFFF;
      border-radius: 20px;
      box-sizing: border-box;
      transition: all .3s;
      .img {
        width: 100%;
        height: auto;
        aspect-ratio: 280 / 210;
        border-radius: 10px;
        object-fit: cover;
      }
      .title {
        font-family: Source Han Sans CN;
        font-size: 16px;
        line-height: 24px;
        color: #34374A;
        margin-top: 10px;
        -webkit-line-clamp: 2;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
      }
      .time {
        font-family: Source Han Sans CN;
        font-size: 12px;
        font-weight: 350;
        line-height: 24px;
        color: #6F778B;
        margin-top: 16px;
      }
    }
    .list:hover {
      cursor: pointer;
      box-shadow: 0px 4px 20px 0px rgba(196, 204, 224, 0.5);
      transform: translateY(-5px);
    }
  }
}

@media screen and (max-width: 768px){
  .search-new {
    min-height: 100%;
    background: #f6f7f8;
    .logo {
      width: 100%;
      cursor: pointer;
    }
    .search-box {
      width: 80%;
      margin: 20px auto;
    }
    .list-box {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: auto;
      gap: 12px 12px;
      margin: 0 auto;
      .list {
        width: 100%;
        padding: 10px;
        background: #FFFFFF;
        border-radius: 20px;
        box-sizing: border-box;
        transition: all .3s;
        .img {
          width: 100%;
          height: auto;
          aspect-ratio: 280 / 210;
          object-fit: cover;
        }
        .title {
          font-family: Source Han Sans CN;
          font-size: 16px;
          line-height: 24px;
          color: #34374A;
          margin-top: 10px;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
        }
        .time {
          font-family: Source Han Sans CN;
          font-size: 12px;
          font-weight: 350;
          line-height: 24px;
          color: #6F778B;
          margin-top: 16px;
        }
      }
      .list:hover {
        cursor: pointer;
        box-shadow: 0px 4px 20px 0px rgba(196, 204, 224, 0.5);
        transform: translateY(-5px);
      }
    }
  }
}
</style>
